import React from 'react';

const About = () => {
  const products = [
    'Viande de porc',
    'Aliments complets porcs et poulets',
    'Intrants pour l\'alimentation animale (maïs, soja, son de blé)',
    'Equipements d\'élevage de porcs et poulets',
    'Conseil en élevage',
    'Banane plantain',
    'Ananas',
    'Tomate',
    'Poivron',
    'Concombre',
    'Piment',
    'Petits matériels et Equipements pour l\'agriculture',
  ];

  return (
    <div>
      <h2>À propos de K'MDEU FARMS</h2>
      <p>La société K'MDEU FARMS SARL est une entreprise agricole dynamique fondée de fait en 2017 et formalisée en 2020. Le siège social est à Douala au Cameroun et le site d'exploitation est situé à BONEPOUPA dans le Département du NKAM, à environ 45km de la ville de Douala.</p>
      <p>Nous sommes spécialisés dans la production végétale et animale, avec un objectif de maîtriser toute la chaîne de valeur des produits que nous mettons sur le marché.</p>
      <h3>Nos Produits et Services</h3>
      <ul>
        {products.map((product, index) => (
          <li key={index}>{product}</li>
        ))}
      </ul>
    </div>
  );
};

export default About;